import React, { useEffect, useState } from 'react';
import { GetProcessPaymentJson } from '../services/PaymentService';
import RejectedPayment from '../components/RejectedPayment';

function RejectedPaymentP() {
    const [urlRedirect, setUrlRedirect] = useState('');

    const searchParams = React.useMemo(() => new URLSearchParams(window.location.search), []);
    const transactionId = searchParams.get('transactionId');
   
    useEffect(() => {
        console.log(transactionId);

        const fetchData = async () => {
            try {
                const data = await GetProcessPaymentJson(transactionId);
                setUrlRedirect(data.returnURL || '');
            } catch (error) {
            }
        };

        fetchData();
    }, [searchParams, transactionId, urlRedirect]);

    useEffect(() => {
        if (urlRedirect) {
            const timer = setTimeout(() => {
                window.location.assign(urlRedirect);
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [urlRedirect]);

    return (
        <div>
        <div className="min-h-screen bg-gray-100 flex items-center justify-center">
            <div className="bg-white p-9 ml-8 mr-8 rounded-xl shadow-md text-center w-auto max-w-[800px] h-auto max-h-[800px]">
                <RejectedPayment urlRedirect={urlRedirect} />
            </div>
        </div>
        </div>
    ); 
}

export default RejectedPaymentP;